import { Col, PageHeader } from 'antd';
import {
  LeftCol,
  MainContainer,
} from 'app/components/LayoutComponents/LayoutComponents';
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import HarvestByCultureAndCompanyCard from '../../parts/HarvestByCultureAndCompanyCard/HarvestByCultureAndCompanyCard';
import HarvestListCard from '../../parts/HarvestListCard/HarvestListCard';
import { useResourceSlice } from '../../slice';

interface IReactRouterParams {
  cultureId?: string;
}

interface IProps extends RouteComponentProps<IReactRouterParams> {}

const Harvest: FC<IProps> = ({ match: { params } }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { actions } = useResourceSlice();

  useEffect(() => {
    dispatch(
      actions.setHarvestSelectedCultureId(Number(params.cultureId) || null),
    );
  }, [params.cultureId, dispatch, actions]);

  return (
    <>
      <PageHeader
        className="page-header"
        title={t('Resource.Harvest.Title', 'Harvest')}
      />

      <MainContainer>
        <LeftCol>
          <HarvestListCard />
        </LeftCol>
        <Col flex={1}>
          <HarvestByCultureAndCompanyCard />
        </Col>
      </MainContainer>
    </>
  );
};

export default Harvest;
